import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectRank = (state : GlobalState) => state.music.rank;

export const musicRankSelector = createSelector(
    [selectRank],
    (data ) => data
)